import { jsx as ve, jsxs as Dt, Fragment as Wt } from "react/jsx-runtime";
import * as S from "react";
import oe, { useState as Ne, createContext as jt, forwardRef as $t, useRef as Se, useCallback as ie, useEffect as Oe, useMemo as Bt, Fragment as zt, PureComponent as qt } from "react";
import { CloseFillIcon as Ut } from "@ifrc-go/icons";
import { _ as $e } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import Yt from "../Button/index.js";
import Vt from "../Container/index.js";
import Ht from "../Portal/index.js";
import Gt from "../../hooks/useTranslation.js";
import { g as Xt } from "../../_commonjsHelpers-B52_cu2H.js";
import '../../index93.css';var q = function() {
  return q = Object.assign || function(r) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }, q.apply(this, arguments);
};
function ur(e, r) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}
function Zt() {
  for (var e = 0, r = 0, t = arguments.length; r < t; r++) e += arguments[r].length;
  for (var n = Array(e), o = 0, r = 0; r < t; r++)
    for (var a = arguments[r], u = 0, i = a.length; u < i; u++, o++)
      n[o] = a[u];
  return n;
}
function Kt(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}
var Le = "right-scroll-bar-position", De = "width-before-scroll-bar", Jt = "with-scroll-bars-hidden", Qt = "--removed-body-scroll-bar-size";
function Be(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function en(e, r) {
  var t = Ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(n) {
          var o = t.value;
          o !== n && (t.value = n, t.callback(n, o));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var rn = typeof window < "u" ? S.useLayoutEffect : S.useEffect, Pr = /* @__PURE__ */ new WeakMap();
function Xr(e, r) {
  var t = en(null, function(n) {
    return e.forEach(function(o) {
      return Be(o, n);
    });
  });
  return rn(function() {
    var n = Pr.get(t);
    if (n) {
      var o = new Set(n), a = new Set(e), u = t.current;
      o.forEach(function(i) {
        a.has(i) || Be(i, null);
      }), a.forEach(function(i) {
        o.has(i) || Be(i, u);
      });
    }
    Pr.set(t, e);
  }, [e]), t;
}
function Zr(e) {
  return e;
}
function Kr(e, r) {
  r === void 0 && (r = Zr);
  var t = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(a) {
      var u = r(a, n);
      return t.push(u), function() {
        t = t.filter(function(i) {
          return i !== u;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; t.length; ) {
        var u = t;
        t = [], u.forEach(a);
      }
      t = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var u = [];
      if (t.length) {
        var i = t;
        t = [], i.forEach(a), u = t;
      }
      var m = function() {
        var h = u;
        u = [], h.forEach(a);
      }, v = function() {
        return Promise.resolve().then(m);
      };
      v(), t = {
        push: function(h) {
          u.push(h), v();
        },
        filter: function(h) {
          return u = u.filter(h), t;
        }
      };
    }
  };
  return o;
}
function cr(e, r) {
  return r === void 0 && (r = Zr), Kr(e, r);
}
function sr(e) {
  e === void 0 && (e = {});
  var r = Kr(null);
  return r.options = q({ async: !0, ssr: !1 }, e), r;
}
var Jr = function(e) {
  var r = e.sideCar, t = ur(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = r.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return S.createElement(n, q({}, t));
};
Jr.isSideCarExport = !0;
function fr(e, r) {
  return e.useMedium(r), Jr;
}
var Qr = sr(), ze = function() {
}, lr = S.forwardRef(function(e, r) {
  var t = S.useRef(null), n = S.useState({
    onScrollCapture: ze,
    onWheelCapture: ze,
    onTouchMoveCapture: ze
  }), o = n[0], a = n[1], u = e.forwardProps, i = e.children, m = e.className, v = e.removeScrollBar, h = e.enabled, s = e.shards, d = e.sideCar, g = e.noRelative, E = e.noIsolation, c = e.inert, y = e.allowPinchZoom, T = e.as, O = T === void 0 ? "div" : T, w = e.gapMode, C = ur(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), f = d, D = Xr([t, r]), j = q(q({}, C), o);
  return S.createElement(
    S.Fragment,
    null,
    h && S.createElement(f, { sideCar: Qr, removeScrollBar: v, shards: s, noRelative: g, noIsolation: E, inert: c, setCallbacks: a, allowPinchZoom: !!y, lockRef: t, gapMode: w }),
    u ? S.cloneElement(S.Children.only(i), q(q({}, j), { ref: D })) : S.createElement(O, q({}, j, { className: m, ref: D }), i)
  );
});
lr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
lr.classNames = {
  fullWidth: De,
  zeroRight: Le
};
function We() {
  return We = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, We.apply(null, arguments);
}
var Re = { exports: {} }, Fe = { exports: {} }, N = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xr;
function tn() {
  if (xr) return N;
  xr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, c = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
  function w(f) {
    if (typeof f == "object" && f !== null) {
      var D = f.$$typeof;
      switch (D) {
        case r:
          switch (f = f.type, f) {
            case m:
            case v:
            case n:
            case a:
            case o:
            case s:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case i:
                case h:
                case E:
                case g:
                case u:
                  return f;
                default:
                  return D;
              }
          }
        case t:
          return D;
      }
    }
  }
  function C(f) {
    return w(f) === v;
  }
  return N.AsyncMode = m, N.ConcurrentMode = v, N.ContextConsumer = i, N.ContextProvider = u, N.Element = r, N.ForwardRef = h, N.Fragment = n, N.Lazy = E, N.Memo = g, N.Portal = t, N.Profiler = a, N.StrictMode = o, N.Suspense = s, N.isAsyncMode = function(f) {
    return C(f) || w(f) === m;
  }, N.isConcurrentMode = C, N.isContextConsumer = function(f) {
    return w(f) === i;
  }, N.isContextProvider = function(f) {
    return w(f) === u;
  }, N.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === r;
  }, N.isForwardRef = function(f) {
    return w(f) === h;
  }, N.isFragment = function(f) {
    return w(f) === n;
  }, N.isLazy = function(f) {
    return w(f) === E;
  }, N.isMemo = function(f) {
    return w(f) === g;
  }, N.isPortal = function(f) {
    return w(f) === t;
  }, N.isProfiler = function(f) {
    return w(f) === a;
  }, N.isStrictMode = function(f) {
    return w(f) === o;
  }, N.isSuspense = function(f) {
    return w(f) === s;
  }, N.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === n || f === v || f === a || f === o || f === s || f === d || typeof f == "object" && f !== null && (f.$$typeof === E || f.$$typeof === g || f.$$typeof === u || f.$$typeof === i || f.$$typeof === h || f.$$typeof === y || f.$$typeof === T || f.$$typeof === O || f.$$typeof === c);
  }, N.typeOf = w, N;
}
var L = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _r;
function nn() {
  return _r || (_r = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, c = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
    function w(p) {
      return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      p === n || p === v || p === a || p === o || p === s || p === d || typeof p == "object" && p !== null && (p.$$typeof === E || p.$$typeof === g || p.$$typeof === u || p.$$typeof === i || p.$$typeof === h || p.$$typeof === y || p.$$typeof === T || p.$$typeof === O || p.$$typeof === c);
    }
    function C(p) {
      if (typeof p == "object" && p !== null) {
        var Y = p.$$typeof;
        switch (Y) {
          case r:
            var fe = p.type;
            switch (fe) {
              case m:
              case v:
              case n:
              case a:
              case o:
              case s:
                return fe;
              default:
                var _e = fe && fe.$$typeof;
                switch (_e) {
                  case i:
                  case h:
                  case E:
                  case g:
                  case u:
                    return _e;
                  default:
                    return Y;
                }
            }
          case t:
            return Y;
        }
      }
    }
    var f = m, D = v, j = i, V = u, H = r, Q = h, U = n, G = E, ee = g, X = t, te = a, B = o, Z = s, ne = !1;
    function se(p) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), l(p) || C(p) === m;
    }
    function l(p) {
      return C(p) === v;
    }
    function b(p) {
      return C(p) === i;
    }
    function _(p) {
      return C(p) === u;
    }
    function x(p) {
      return typeof p == "object" && p !== null && p.$$typeof === r;
    }
    function P(p) {
      return C(p) === h;
    }
    function A(p) {
      return C(p) === n;
    }
    function R(p) {
      return C(p) === E;
    }
    function F(p) {
      return C(p) === g;
    }
    function I(p) {
      return C(p) === t;
    }
    function M(p) {
      return C(p) === a;
    }
    function k(p) {
      return C(p) === o;
    }
    function $(p) {
      return C(p) === s;
    }
    L.AsyncMode = f, L.ConcurrentMode = D, L.ContextConsumer = j, L.ContextProvider = V, L.Element = H, L.ForwardRef = Q, L.Fragment = U, L.Lazy = G, L.Memo = ee, L.Portal = X, L.Profiler = te, L.StrictMode = B, L.Suspense = Z, L.isAsyncMode = se, L.isConcurrentMode = l, L.isContextConsumer = b, L.isContextProvider = _, L.isElement = x, L.isForwardRef = P, L.isFragment = A, L.isLazy = R, L.isMemo = F, L.isPortal = I, L.isProfiler = M, L.isStrictMode = k, L.isSuspense = $, L.isValidElementType = w, L.typeOf = C;
  })()), L;
}
var Rr;
function et() {
  return Rr || (Rr = 1, process.env.NODE_ENV === "production" ? Fe.exports = tn() : Fe.exports = nn()), Fe.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var qe, Fr;
function on() {
  if (Fr) return qe;
  Fr = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var u = {}, i = 0; i < 10; i++)
        u["_" + String.fromCharCode(i)] = i;
      var m = Object.getOwnPropertyNames(u).map(function(h) {
        return u[h];
      });
      if (m.join("") !== "0123456789")
        return !1;
      var v = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        v[h] = h;
      }), Object.keys(Object.assign({}, v)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return qe = o() ? Object.assign : function(a, u) {
    for (var i, m = n(a), v, h = 1; h < arguments.length; h++) {
      i = Object(arguments[h]);
      for (var s in i)
        r.call(i, s) && (m[s] = i[s]);
      if (e) {
        v = e(i);
        for (var d = 0; d < v.length; d++)
          t.call(i, v[d]) && (m[v[d]] = i[v[d]]);
      }
    }
    return m;
  }, qe;
}
var Ue, Ar;
function dr() {
  if (Ar) return Ue;
  Ar = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ue = e, Ue;
}
var Ye, Ir;
function rt() {
  return Ir || (Ir = 1, Ye = Function.call.bind(Object.prototype.hasOwnProperty)), Ye;
}
var Ve, kr;
function an() {
  if (kr) return Ve;
  kr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ dr(), t = {}, n = /* @__PURE__ */ rt();
    e = function(a) {
      var u = "Warning: " + a;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function o(a, u, i, m, v) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in a)
        if (n(a, h)) {
          var s;
          try {
            if (typeof a[h] != "function") {
              var d = Error(
                (m || "React class") + ": " + i + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            s = a[h](u, h, m, i, null, r);
          } catch (E) {
            s = E;
          }
          if (s && !(s instanceof Error) && e(
            (m || "React class") + ": type specification of " + i + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), s instanceof Error && !(s.message in t)) {
            t[s.message] = !0;
            var g = v ? v() : "";
            e(
              "Failed " + i + " type: " + s.message + (g ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Ve = o, Ve;
}
var He, Mr;
function un() {
  if (Mr) return He;
  Mr = 1;
  var e = et(), r = on(), t = /* @__PURE__ */ dr(), n = /* @__PURE__ */ rt(), o = /* @__PURE__ */ an(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(i) {
    var m = "Warning: " + i;
    typeof console < "u" && console.error(m);
    try {
      throw new Error(m);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return He = function(i, m) {
    var v = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function s(l) {
      var b = l && (v && l[v] || l[h]);
      if (typeof b == "function")
        return b;
    }
    var d = "<<anonymous>>", g = {
      array: T("array"),
      bigint: T("bigint"),
      bool: T("boolean"),
      func: T("function"),
      number: T("number"),
      object: T("object"),
      string: T("string"),
      symbol: T("symbol"),
      any: O(),
      arrayOf: w,
      element: C(),
      elementType: f(),
      instanceOf: D,
      node: Q(),
      objectOf: V,
      oneOf: j,
      oneOfType: H,
      shape: G,
      exact: ee
    };
    function E(l, b) {
      return l === b ? l !== 0 || 1 / l === 1 / b : l !== l && b !== b;
    }
    function c(l, b) {
      this.message = l, this.data = b && typeof b == "object" ? b : {}, this.stack = "";
    }
    c.prototype = Error.prototype;
    function y(l) {
      if (process.env.NODE_ENV !== "production")
        var b = {}, _ = 0;
      function x(A, R, F, I, M, k, $) {
        if (I = I || d, k = k || F, $ !== t) {
          if (m) {
            var p = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw p.name = "Invariant Violation", p;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Y = I + ":" + F;
            !b[Y] && // Avoid spamming the console because they are often not actionable except for lib authors
            _ < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + k + "` prop on `" + I + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), b[Y] = !0, _++);
          }
        }
        return R[F] == null ? A ? R[F] === null ? new c("The " + M + " `" + k + "` is marked as required " + ("in `" + I + "`, but its value is `null`.")) : new c("The " + M + " `" + k + "` is marked as required in " + ("`" + I + "`, but its value is `undefined`.")) : null : l(R, F, I, M, k);
      }
      var P = x.bind(null, !1);
      return P.isRequired = x.bind(null, !0), P;
    }
    function T(l) {
      function b(_, x, P, A, R, F) {
        var I = _[x], M = B(I);
        if (M !== l) {
          var k = Z(I);
          return new c(
            "Invalid " + A + " `" + R + "` of type " + ("`" + k + "` supplied to `" + P + "`, expected ") + ("`" + l + "`."),
            { expectedType: l }
          );
        }
        return null;
      }
      return y(b);
    }
    function O() {
      return y(u);
    }
    function w(l) {
      function b(_, x, P, A, R) {
        if (typeof l != "function")
          return new c("Property `" + R + "` of component `" + P + "` has invalid PropType notation inside arrayOf.");
        var F = _[x];
        if (!Array.isArray(F)) {
          var I = B(F);
          return new c("Invalid " + A + " `" + R + "` of type " + ("`" + I + "` supplied to `" + P + "`, expected an array."));
        }
        for (var M = 0; M < F.length; M++) {
          var k = l(F, M, P, A, R + "[" + M + "]", t);
          if (k instanceof Error)
            return k;
        }
        return null;
      }
      return y(b);
    }
    function C() {
      function l(b, _, x, P, A) {
        var R = b[_];
        if (!i(R)) {
          var F = B(R);
          return new c("Invalid " + P + " `" + A + "` of type " + ("`" + F + "` supplied to `" + x + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(l);
    }
    function f() {
      function l(b, _, x, P, A) {
        var R = b[_];
        if (!e.isValidElementType(R)) {
          var F = B(R);
          return new c("Invalid " + P + " `" + A + "` of type " + ("`" + F + "` supplied to `" + x + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(l);
    }
    function D(l) {
      function b(_, x, P, A, R) {
        if (!(_[x] instanceof l)) {
          var F = l.name || d, I = se(_[x]);
          return new c("Invalid " + A + " `" + R + "` of type " + ("`" + I + "` supplied to `" + P + "`, expected ") + ("instance of `" + F + "`."));
        }
        return null;
      }
      return y(b);
    }
    function j(l) {
      if (!Array.isArray(l))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), u;
      function b(_, x, P, A, R) {
        for (var F = _[x], I = 0; I < l.length; I++)
          if (E(F, l[I]))
            return null;
        var M = JSON.stringify(l, function($, p) {
          var Y = Z(p);
          return Y === "symbol" ? String(p) : p;
        });
        return new c("Invalid " + A + " `" + R + "` of value `" + String(F) + "` " + ("supplied to `" + P + "`, expected one of " + M + "."));
      }
      return y(b);
    }
    function V(l) {
      function b(_, x, P, A, R) {
        if (typeof l != "function")
          return new c("Property `" + R + "` of component `" + P + "` has invalid PropType notation inside objectOf.");
        var F = _[x], I = B(F);
        if (I !== "object")
          return new c("Invalid " + A + " `" + R + "` of type " + ("`" + I + "` supplied to `" + P + "`, expected an object."));
        for (var M in F)
          if (n(F, M)) {
            var k = l(F, M, P, A, R + "." + M, t);
            if (k instanceof Error)
              return k;
          }
        return null;
      }
      return y(b);
    }
    function H(l) {
      if (!Array.isArray(l))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var b = 0; b < l.length; b++) {
        var _ = l[b];
        if (typeof _ != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(_) + " at index " + b + "."
          ), u;
      }
      function x(P, A, R, F, I) {
        for (var M = [], k = 0; k < l.length; k++) {
          var $ = l[k], p = $(P, A, R, F, I, t);
          if (p == null)
            return null;
          p.data && n(p.data, "expectedType") && M.push(p.data.expectedType);
        }
        var Y = M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "";
        return new c("Invalid " + F + " `" + I + "` supplied to " + ("`" + R + "`" + Y + "."));
      }
      return y(x);
    }
    function Q() {
      function l(b, _, x, P, A) {
        return X(b[_]) ? null : new c("Invalid " + P + " `" + A + "` supplied to " + ("`" + x + "`, expected a ReactNode."));
      }
      return y(l);
    }
    function U(l, b, _, x, P) {
      return new c(
        (l || "React class") + ": " + b + " type `" + _ + "." + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + P + "`."
      );
    }
    function G(l) {
      function b(_, x, P, A, R) {
        var F = _[x], I = B(F);
        if (I !== "object")
          return new c("Invalid " + A + " `" + R + "` of type `" + I + "` " + ("supplied to `" + P + "`, expected `object`."));
        for (var M in l) {
          var k = l[M];
          if (typeof k != "function")
            return U(P, A, R, M, Z(k));
          var $ = k(F, M, P, A, R + "." + M, t);
          if ($)
            return $;
        }
        return null;
      }
      return y(b);
    }
    function ee(l) {
      function b(_, x, P, A, R) {
        var F = _[x], I = B(F);
        if (I !== "object")
          return new c("Invalid " + A + " `" + R + "` of type `" + I + "` " + ("supplied to `" + P + "`, expected `object`."));
        var M = r({}, _[x], l);
        for (var k in M) {
          var $ = l[k];
          if (n(l, k) && typeof $ != "function")
            return U(P, A, R, k, Z($));
          if (!$)
            return new c(
              "Invalid " + A + " `" + R + "` key `" + k + "` supplied to `" + P + "`.\nBad object: " + JSON.stringify(_[x], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(l), null, "  ")
            );
          var p = $(F, k, P, A, R + "." + k, t);
          if (p)
            return p;
        }
        return null;
      }
      return y(b);
    }
    function X(l) {
      switch (typeof l) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !l;
        case "object":
          if (Array.isArray(l))
            return l.every(X);
          if (l === null || i(l))
            return !0;
          var b = s(l);
          if (b) {
            var _ = b.call(l), x;
            if (b !== l.entries) {
              for (; !(x = _.next()).done; )
                if (!X(x.value))
                  return !1;
            } else
              for (; !(x = _.next()).done; ) {
                var P = x.value;
                if (P && !X(P[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function te(l, b) {
      return l === "symbol" ? !0 : b ? b["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && b instanceof Symbol : !1;
    }
    function B(l) {
      var b = typeof l;
      return Array.isArray(l) ? "array" : l instanceof RegExp ? "object" : te(b, l) ? "symbol" : b;
    }
    function Z(l) {
      if (typeof l > "u" || l === null)
        return "" + l;
      var b = B(l);
      if (b === "object") {
        if (l instanceof Date)
          return "date";
        if (l instanceof RegExp)
          return "regexp";
      }
      return b;
    }
    function ne(l) {
      var b = Z(l);
      switch (b) {
        case "array":
        case "object":
          return "an " + b;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + b;
        default:
          return b;
      }
    }
    function se(l) {
      return !l.constructor || !l.constructor.name ? d : l.constructor.name;
    }
    return g.checkPropTypes = o, g.resetWarningCache = o.resetWarningCache, g.PropTypes = g, g;
  }, He;
}
var Ge, Nr;
function cn() {
  if (Nr) return Ge;
  Nr = 1;
  var e = /* @__PURE__ */ dr();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Ge = function() {
    function n(u, i, m, v, h, s) {
      if (s !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return a.PropTypes = a, a;
  }, Ge;
}
var Lr;
function sn() {
  if (Lr) return Re.exports;
  if (Lr = 1, process.env.NODE_ENV !== "production") {
    var e = et(), r = !0;
    Re.exports = /* @__PURE__ */ un()(e.isElement, r);
  } else
    Re.exports = /* @__PURE__ */ cn()();
  return Re.exports;
}
var W = /* @__PURE__ */ sn();
const tt = /* @__PURE__ */ Xt(W);
var rr = "data-focus-lock", nt = "data-focus-lock-disabled", fn = "data-no-focus-lock", ln = "data-autofocus-inside", dn = "data-no-autofocus", Xe = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && tt.node;
var ot = cr({}, function(e) {
  var r = e.target, t = e.currentTarget;
  return {
    target: r,
    currentTarget: t
  };
}), at = cr(), vn = cr(), it = sr({
  async: !0,
  ssr: typeof document < "u"
}), mn = /* @__PURE__ */ jt(void 0), hn = [], ut = /* @__PURE__ */ $t(function(r, t) {
  var n, o = Ne(), a = o[0], u = o[1], i = Se(), m = Se(!1), v = Se(null), h = Ne({}), s = h[1], d = r.children, g = r.disabled, E = g === void 0 ? !1 : g, c = r.noFocusGuards, y = c === void 0 ? !1 : c, T = r.persistentFocus, O = T === void 0 ? !1 : T, w = r.crossFrame, C = w === void 0 ? !0 : w, f = r.autoFocus, D = f === void 0 ? !0 : f, j = r.allowTextSelection, V = r.group, H = r.className, Q = r.whiteList, U = r.hasPositiveIndices, G = r.shards, ee = G === void 0 ? hn : G, X = r.as, te = X === void 0 ? "div" : X, B = r.lockProps, Z = B === void 0 ? {} : B, ne = r.sideCar, se = r.returnFocus, l = se === void 0 ? !1 : se, b = r.focusOptions, _ = r.onActivation, x = r.onDeactivation, P = Ne({}), A = P[0], R = ie(function(re) {
    var le = re.captureFocusRestore;
    if (!v.current) {
      var de, ae = (de = document) == null ? void 0 : de.activeElement;
      v.current = ae, ae !== document.body && (v.current = le(ae));
    }
    i.current && _ && _(i.current), m.current = !0, s();
  }, [_]), F = ie(function() {
    m.current = !1, x && x(i.current), s();
  }, [x]), I = ie(function(re) {
    var le = v.current;
    if (le) {
      var de = (typeof le == "function" ? le() : le) || document.body, ae = typeof l == "function" ? l(de) : l;
      if (ae) {
        var Cr = typeof ae == "object" ? ae : void 0;
        v.current = null, re ? Promise.resolve().then(function() {
          return de.focus(Cr);
        }) : de.focus(Cr);
      }
    }
  }, [l]), M = ie(function(re) {
    m.current && ot.useMedium(re);
  }, []), k = at.useMedium, $ = ie(function(re) {
    i.current !== re && (i.current = re, u(re));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof j < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), Oe(function() {
    !i.current && typeof te != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var p = We((n = {}, n[nt] = E && "disabled", n[rr] = V, n), Z), Y = y !== !0, fe = Y && y !== "tail", _e = Xr([t, $]), Lt = Bt(function() {
    return {
      observed: i,
      shards: ee,
      enabled: !E,
      get active() {
        return m.current;
      }
    };
  }, [E, m, ee, i]);
  return /* @__PURE__ */ oe.createElement(zt, null, Y && [
    /* @__PURE__ */ oe.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: E ? -1 : 0,
      style: Xe
    }),
    U ? /* @__PURE__ */ oe.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: E ? -1 : 1,
      style: Xe
    }) : null
  ], !E && /* @__PURE__ */ oe.createElement(ne, {
    id: A,
    sideCar: it,
    observed: a,
    disabled: E,
    persistentFocus: O,
    crossFrame: C,
    autoFocus: D,
    whiteList: Q,
    shards: ee,
    onActivation: R,
    onDeactivation: F,
    returnFocus: I,
    focusOptions: b,
    noFocusGuards: y
  }), /* @__PURE__ */ oe.createElement(te, We({
    ref: _e
  }, p, {
    className: H,
    onBlur: k,
    onFocus: M
  }), /* @__PURE__ */ oe.createElement(mn.Provider, {
    value: Lt
  }, d)), fe && /* @__PURE__ */ oe.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: E ? -1 : 0,
    style: Xe
  }));
});
ut.propTypes = process.env.NODE_ENV !== "production" ? {
  children: W.node,
  disabled: W.bool,
  returnFocus: W.oneOfType([W.bool, W.object, W.func]),
  focusOptions: W.object,
  noFocusGuards: W.bool,
  hasPositiveIndices: W.bool,
  allowTextSelection: W.bool,
  autoFocus: W.bool,
  persistentFocus: W.bool,
  crossFrame: W.bool,
  group: W.string,
  className: W.string,
  whiteList: W.func,
  shards: W.arrayOf(W.any),
  as: W.oneOfType([W.string, W.func, W.object]),
  lockProps: W.object,
  onActivation: W.func,
  onDeactivation: W.func,
  sideCar: W.any.isRequired
} : {};
function vr(e) {
  setTimeout(e, 1);
}
var pn = function(r) {
  return r && "current" in r ? r.current : r;
}, ct = sr(), st = "data-focus-on-hidden", yn = { preventScroll: !0 }, bn = S.forwardRef(function(e, r) {
  var t = S.useState(!1), n = t[0], o = t[1], a = S.useState(null), u = a[0], i = a[1], m = e.children, v = e.autoFocus, h = e.shards, s = e.crossFrame, d = e.enabled, g = d === void 0 ? !0 : d, E = e.scrollLock, c = E === void 0 ? !0 : E, y = e.focusLock, T = y === void 0 ? !0 : y, O = e.returnFocus, w = O === void 0 ? !0 : O, C = e.inert, f = e.allowPinchZoom, D = e.sideCar, j = e.className, V = e.shouldIgnore, H = e.preventScrollOnFocus, Q = e.style, U = e.as, G = e.gapMode, ee = ur(e, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]), X = D, te = q(q({}, n), {
    as: U,
    style: Q,
    sideCar: D,
    shards: h,
    allowPinchZoom: f,
    gapMode: G,
    inert: C,
    enabled: g && c
  }), B = S.useCallback(function(ne) {
    i(ne);
  }, []), Z = S.useCallback(function() {
    i(null);
  }, []);
  return S.createElement(
    S.Fragment,
    null,
    S.createElement(ut, {
      ref: r,
      sideCar: D,
      disabled: !(g && T),
      returnFocus: w,
      autoFocus: v,
      shards: h,
      crossFrame: s,
      onActivation: B,
      onDeactivation: Z,
      className: j,
      whiteList: V,
      lockProps: te,
      focusOptions: H ? yn : void 0,
      // // ts-expect-error TS2322 - ts v3 "glitch"
      as: lr
    }, m),
    g && S.createElement(X, q({}, ee, { sideCar: ct, setLockProps: o, shards: h, activeNode: u }))
  );
});
function tr(e, r) {
  return tr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, tr(e, r);
}
function gn(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, tr(e, r);
}
function Te(e) {
  "@babel/helpers - typeof";
  return Te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Te(e);
}
function En(e, r) {
  if (Te(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (Te(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function wn(e) {
  var r = En(e, "string");
  return Te(r) == "symbol" ? r : r + "";
}
function Sn(e, r, t) {
  return (r = wn(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function On(e, r) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof r != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function t(n) {
    return n.displayName || n.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var a = [], u;
    function i() {
      u = e(a.map(function(v) {
        return v.props;
      })), r(u);
    }
    var m = /* @__PURE__ */ (function(v) {
      gn(h, v);
      function h() {
        return v.apply(this, arguments) || this;
      }
      h.peek = function() {
        return u;
      };
      var s = h.prototype;
      return s.componentDidMount = function() {
        a.push(this), i();
      }, s.componentDidUpdate = function() {
        i();
      }, s.componentWillUnmount = function() {
        var g = a.indexOf(this);
        a.splice(g, 1), i();
      }, s.render = function() {
        return /* @__PURE__ */ oe.createElement(o, this.props);
      }, h;
    })(qt);
    return Sn(m, "displayName", "SideEffect(" + t(o) + ")"), m;
  };
}
var J = function(e) {
  for (var r = Array(e.length), t = 0; t < e.length; ++t)
    r[t] = e[t];
  return r;
}, ce = function(e) {
  return Array.isArray(e) ? e : [e];
}, ft = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, Tn = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var r = window.getComputedStyle(e, null);
  return !r || !r.getPropertyValue ? !1 : r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}, lt = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, dt = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, Cn = function(e) {
  return e.hasAttribute("inert");
}, Pn = function(e, r) {
  return !e || dt(e) || !Tn(e) && !Cn(e) && r(lt(e));
}, vt = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = Pn(r, vt.bind(void 0, e));
  return e.set(r, n), n;
}, xn = function(e, r) {
  return e && !dt(e) ? Fn(e) ? r(lt(e)) : !1 : !0;
}, mt = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = xn(r, mt.bind(void 0, e));
  return e.set(r, n), n;
}, ht = function(e) {
  return e.dataset;
}, _n = function(e) {
  return e.tagName === "BUTTON";
}, pt = function(e) {
  return e.tagName === "INPUT";
}, yt = function(e) {
  return pt(e) && e.type === "radio";
}, Rn = function(e) {
  return !((pt(e) || _n(e)) && (e.type === "hidden" || e.disabled));
}, Fn = function(e) {
  var r = e.getAttribute(dn);
  return ![!0, "true", ""].includes(r);
}, mr = function(e) {
  var r;
  return !!(e && (!((r = ht(e)) === null || r === void 0) && r.focusGuard));
}, nr = function(e) {
  return !mr(e);
}, An = function(e) {
  return !!e;
}, In = function(e, r) {
  var t = Math.max(0, e.tabIndex), n = Math.max(0, r.tabIndex), o = t - n, a = e.index - r.index;
  if (o) {
    if (!t)
      return 1;
    if (!n)
      return -1;
  }
  return o || a;
}, kn = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, hr = function(e, r, t) {
  return J(e).map(function(n, o) {
    var a = kn(n);
    return {
      node: n,
      index: o,
      tabIndex: t && a === -1 ? (n.dataset || {}).focusGuard ? 0 : -1 : a
    };
  }).filter(function(n) {
    return !r || n.tabIndex >= 0;
  }).sort(In);
}, Mn = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], pr = Mn.join(","), Nn = "".concat(pr, ", [data-focus-guard]"), bt = function(e, r) {
  return J((e.shadowRoot || e).children).reduce(function(t, n) {
    return t.concat(n.matches(r ? Nn : pr) ? [n] : [], bt(n));
  }, []);
}, Ln = function(e, r) {
  var t;
  return e instanceof HTMLIFrameElement && (!((t = e.contentDocument) === null || t === void 0) && t.body) ? Ee([e.contentDocument.body], r) : [e];
}, Ee = function(e, r) {
  return e.reduce(function(t, n) {
    var o, a = bt(n, r), u = (o = []).concat.apply(o, a.map(function(i) {
      return Ln(i, r);
    }));
    return t.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      u,
      // add if node is tabbable itself
      n.parentNode ? J(n.parentNode.querySelectorAll(pr)).filter(function(i) {
        return i === n;
      }) : []
    );
  }, []);
}, Dn = function(e) {
  var r = e.querySelectorAll("[".concat(ln, "]"));
  return J(r).map(function(t) {
    return Ee([t]);
  }).reduce(function(t, n) {
    return t.concat(n);
  }, []);
}, yr = function(e, r) {
  return J(e).filter(function(t) {
    return vt(r, t);
  }).filter(function(t) {
    return Rn(t);
  });
}, Dr = function(e, r) {
  return r === void 0 && (r = /* @__PURE__ */ new Map()), J(e).filter(function(t) {
    return mt(r, t);
  });
}, br = function(e, r, t) {
  return hr(yr(Ee(e, t), r), !0, t);
}, Ce = function(e, r) {
  return hr(yr(Ee(e), r), !1);
}, Wn = function(e, r) {
  return yr(Dn(e), r);
}, ue = function(e, r) {
  return e.shadowRoot ? ue(e.shadowRoot, r) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, r) ? !0 : J(e.children).some(function(t) {
    var n;
    if (t instanceof HTMLIFrameElement) {
      var o = (n = t.contentDocument) === null || n === void 0 ? void 0 : n.body;
      return o ? ue(o, r) : !1;
    }
    return ue(t, r);
  });
}, jn = function(e) {
  for (var r = /* @__PURE__ */ new Set(), t = e.length, n = 0; n < t; n += 1)
    for (var o = n + 1; o < t; o += 1) {
      var a = e[n].compareDocumentPosition(e[o]);
      (a & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && r.add(o), (a & Node.DOCUMENT_POSITION_CONTAINS) > 0 && r.add(n);
    }
  return e.filter(function(u, i) {
    return !r.has(i);
  });
}, gt = function(e) {
  return e.parentNode ? gt(e.parentNode) : e;
}, gr = function(e) {
  var r = ce(e);
  return r.filter(Boolean).reduce(function(t, n) {
    var o = n.getAttribute(rr);
    return t.push.apply(t, o ? jn(J(gt(n).querySelectorAll("[".concat(rr, '="').concat(o, '"]:not([').concat(nt, '="disabled"])')))) : [n]), t;
  }, []);
}, $n = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, Pe = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var r = e.activeElement;
    return r.shadowRoot ? Pe(r.shadowRoot) : r instanceof HTMLIFrameElement && $n(function() {
      return r.contentWindow.document;
    }) ? Pe(r.contentWindow.document) : r;
  }
}, Bn = function(e, r) {
  return e === r;
}, zn = function(e, r) {
  return !!J(e.querySelectorAll("iframe")).some(function(t) {
    return Bn(t, r);
  });
}, Et = function(e, r) {
  return r === void 0 && (r = Pe(ft(e).ownerDocument)), !r || r.dataset && r.dataset.focusGuard ? !1 : gr(e).some(function(t) {
    return ue(t, r) || zn(t, r);
  });
}, qn = function(e) {
  e === void 0 && (e = document);
  var r = Pe(e);
  return r ? J(e.querySelectorAll("[".concat(fn, "]"))).some(function(t) {
    return ue(t, r);
  }) : !1;
}, Un = function(e, r) {
  return r.filter(yt).filter(function(t) {
    return t.name === e.name;
  }).filter(function(t) {
    return t.checked;
  })[0] || e;
}, Er = function(e, r) {
  return yt(e) && e.name ? Un(e, r) : e;
}, Yn = function(e) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(t) {
    return r.add(Er(t, e));
  }), e.filter(function(t) {
    return r.has(t);
  });
}, Wr = function(e) {
  return e[0] && e.length > 1 ? Er(e[0], e) : e[0];
}, jr = function(e, r) {
  return e.indexOf(Er(r, e));
}, or = "NEW_FOCUS", Vn = function(e, r, t, n, o) {
  var a = e.length, u = e[0], i = e[a - 1], m = mr(n);
  if (!(n && e.indexOf(n) >= 0)) {
    var v = n !== void 0 ? t.indexOf(n) : -1, h = o ? t.indexOf(o) : v, s = o ? e.indexOf(o) : -1;
    if (v === -1)
      return s !== -1 ? s : or;
    if (s === -1)
      return or;
    var d = v - h, g = t.indexOf(u), E = t.indexOf(i), c = Yn(t), y = n !== void 0 ? c.indexOf(n) : -1, T = o ? c.indexOf(o) : y, O = c.filter(function(V) {
      return V.tabIndex >= 0;
    }), w = n !== void 0 ? O.indexOf(n) : -1, C = o ? O.indexOf(o) : w, f = w >= 0 && C >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      C - w
    ) : (
      // or else measure in focusable space
      T - y
    );
    if (!d && s >= 0 || r.length === 0)
      return s;
    var D = jr(e, r[0]), j = jr(e, r[r.length - 1]);
    if (v <= g && m && Math.abs(d) > 1)
      return j;
    if (v >= E && m && Math.abs(d) > 1)
      return D;
    if (d && Math.abs(f) > 1)
      return s;
    if (v <= g)
      return j;
    if (v > E)
      return D;
    if (d)
      return Math.abs(d) > 1 ? s : (a + s + d) % a;
  }
}, Hn = function(e) {
  return function(r) {
    var t, n = (t = ht(r)) === null || t === void 0 ? void 0 : t.autofocus;
    return (
      // @ts-expect-error
      r.autofocus || //
      n !== void 0 && n !== "false" || //
      e.indexOf(r) >= 0
    );
  };
}, $r = function(e, r, t) {
  var n = e.map(function(a) {
    var u = a.node;
    return u;
  }), o = Dr(n.filter(Hn(t)));
  return o && o.length ? Wr(o) : Wr(Dr(r));
}, ar = function(e, r) {
  return r === void 0 && (r = []), r.push(e), e.parentNode && ar(e.parentNode.host || e.parentNode, r), r;
}, Ze = function(e, r) {
  for (var t = ar(e), n = ar(r), o = 0; o < t.length; o += 1) {
    var a = t[o];
    if (n.indexOf(a) >= 0)
      return a;
  }
  return !1;
}, wt = function(e, r, t) {
  var n = ce(e), o = ce(r), a = n[0], u = !1;
  return o.filter(Boolean).forEach(function(i) {
    u = Ze(u || i, i) || u, t.filter(Boolean).forEach(function(m) {
      var v = Ze(a, m);
      v && (!u || ue(v, u) ? u = v : u = Ze(v, u));
    });
  }), u;
}, Br = function(e, r) {
  return e.reduce(function(t, n) {
    return t.concat(Wn(n, r));
  }, []);
}, Gn = function(e, r) {
  var t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    return t.set(n.node, n);
  }), e.map(function(n) {
    return t.get(n);
  }).filter(An);
}, Xn = function(e, r) {
  var t = Pe(ce(e).length > 0 ? document : ft(e).ownerDocument), n = gr(e).filter(nr), o = wt(t || e, e, n), a = /* @__PURE__ */ new Map(), u = Ce(n, a), i = u.filter(function(E) {
    var c = E.node;
    return nr(c);
  });
  if (i[0]) {
    var m = Ce([o], a).map(function(E) {
      var c = E.node;
      return c;
    }), v = Gn(m, i), h = v.map(function(E) {
      var c = E.node;
      return c;
    }), s = v.filter(function(E) {
      var c = E.tabIndex;
      return c >= 0;
    }).map(function(E) {
      var c = E.node;
      return c;
    }), d = Vn(h, s, m, t, r);
    if (d === or) {
      var g = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        $r(u, s, Br(n, a)) || $r(u, h, Br(n, a))
      );
      if (g)
        return { node: g };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return d === void 0 ? d : v[d];
  }
}, Zn = function(e) {
  var r = gr(e).filter(nr), t = wt(e, e, r), n = hr(Ee([t], !0), !0, !0), o = Ee(r, !1);
  return n.map(function(a) {
    var u = a.node, i = a.index;
    return {
      node: u,
      index: i,
      lockItem: o.indexOf(u) >= 0,
      guard: mr(u)
    };
  });
}, wr = function(e, r) {
  e && ("focus" in e && e.focus(r), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, Ke = 0, Je = !1, St = function(e, r, t) {
  t === void 0 && (t = {});
  var n = Xn(e, r);
  if (!Je && n) {
    if (Ke > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Je = !0, setTimeout(function() {
        Je = !1;
      }, 1);
      return;
    }
    Ke++, wr(n.node, t.focusOptions), Ke--;
  }
};
function we(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var r = e ? new WeakRef(e) : null;
  return function() {
    return (r == null ? void 0 : r.deref()) || null;
  };
}
var Kn = function(e) {
  if (!e)
    return null;
  for (var r = [], t = e; t && t !== document.body; )
    r.push({
      current: we(t),
      parent: we(t.parentElement),
      left: we(t.previousElementSibling),
      right: we(t.nextElementSibling)
    }), t = t.parentElement;
  return {
    element: we(e),
    stack: r,
    ownerDocument: e.ownerDocument
  };
}, Jn = function(e) {
  var r, t, n, o, a;
  if (e)
    for (var u = e.stack, i = e.ownerDocument, m = /* @__PURE__ */ new Map(), v = 0, h = u; v < h.length; v++) {
      var s = h[v], d = (r = s.parent) === null || r === void 0 ? void 0 : r.call(s);
      if (d && i.contains(d)) {
        for (var g = (t = s.left) === null || t === void 0 ? void 0 : t.call(s), E = s.current(), c = d.contains(E) ? E : void 0, y = (n = s.right) === null || n === void 0 ? void 0 : n.call(s), T = br([d], m), O = (
          // that is element itself
          (a = (o = c ?? // or something in it's place
          (g == null ? void 0 : g.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && a !== void 0 ? a : (
            // or somebody to the left, something?
            g
          )
        ); O; ) {
          for (var w = 0, C = T; w < C.length; w++) {
            var f = C[w];
            if (O != null && O.contains(f.node))
              return f.node;
          }
          O = O.nextElementSibling;
        }
        if (T.length)
          return T[0].node;
      }
    }
}, Ot = function(e) {
  var r = Kn(e);
  return function() {
    return Jn(r);
  };
}, Qn = function(e, r, t) {
  if (!e || !r)
    return console.error("no element or scope given"), {};
  var n = ce(r);
  if (n.every(function(u) {
    return !ue(u, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = t ? br(n, /* @__PURE__ */ new Map()) : Ce(n, /* @__PURE__ */ new Map()), a = o.findIndex(function(u) {
    var i = u.node;
    return i === e;
  });
  if (a !== -1)
    return {
      prev: o[a - 1],
      next: o[a + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, eo = function(e, r) {
  var t = r ? br(ce(e), /* @__PURE__ */ new Map()) : Ce(ce(e), /* @__PURE__ */ new Map());
  return {
    first: t[0],
    last: t[t.length - 1]
  };
}, ro = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, Tt = function(e, r, t) {
  r === void 0 && (r = {});
  var n = ro(r), o = Qn(e, n.scope, n.onlyTabbable);
  if (o) {
    var a = t(o, n.cycle);
    a && wr(a.node, n.focusOptions);
  }
}, to = function(e, r) {
  r === void 0 && (r = {}), Tt(e, r, function(t, n) {
    var o = t.next, a = t.first;
    return o || n && a;
  });
}, no = function(e, r) {
  r === void 0 && (r = {}), Tt(e, r, function(t, n) {
    var o = t.prev, a = t.last;
    return o || n && a;
  });
}, Ct = function(e, r, t) {
  var n, o = eo(e, (n = r.onlyTabbable) !== null && n !== void 0 ? n : !0), a = o[t];
  a && wr(a.node, r.focusOptions);
}, oo = function(e, r) {
  r === void 0 && (r = {}), Ct(e, r, "first");
}, ao = function(e, r) {
  r === void 0 && (r = {}), Ct(e, r, "last");
}, Pt = function() {
  return document && document.activeElement === document.body;
}, io = function() {
  return Pt() || qn();
}, ye = null, z = null, zr = function() {
  return null;
}, be = null, xe = !1, Sr = !1, uo = function() {
  return !0;
}, co = function(r) {
  return (ye.whiteList || uo)(r);
}, so = function(r, t) {
  be = {
    observerNode: r,
    portaledElement: t
  };
}, fo = function(r) {
  return be && be.portaledElement === r;
};
function qr(e, r, t, n) {
  var o = null, a = e;
  do {
    var u = n[a];
    if (u.guard)
      u.node.dataset.focusAutoGuard && (o = u);
    else if (u.lockItem) {
      if (a !== e)
        return;
      o = null;
    } else
      break;
  } while ((a += t) !== r);
  o && (o.node.tabIndex = 0);
}
var lo = function(r) {
  return r ? !!xe : xe === "meanwhile";
}, vo = function e(r, t, n) {
  return t && (t.host === r && (!t.activeElement || n.contains(t.activeElement)) || t.parentNode && e(r, t.parentNode, n));
}, mo = function(r, t) {
  return t.some(function(n) {
    return vo(r, n, n);
  });
}, xt = function(r) {
  return Ce(r, /* @__PURE__ */ new Map());
}, ho = function(r) {
  return !xt([r.parentNode]).some(function(t) {
    return t.node === r;
  });
}, je = function() {
  var r = !1;
  if (ye) {
    var t = ye, n = t.observed, o = t.persistentFocus, a = t.autoFocus, u = t.shards, i = t.crossFrame, m = t.focusOptions, v = t.noFocusGuards, h = n || be && be.portaledElement;
    if (Pt() && z && z !== document.body && (!document.body.contains(z) || ho(z))) {
      var s = zr();
      s && s.focus();
    }
    var d = document && document.activeElement;
    if (h) {
      var g = [h].concat(u.map(pn).filter(Boolean)), E = function() {
        if (!lo(i) || !v || !z || Sr)
          return !1;
        var w = xt(g), C = w.findIndex(function(f) {
          var D = f.node;
          return D === z;
        });
        return C === 0 || C === w.length - 1;
      };
      if ((!d || co(d)) && (o || E() || !io() || !z && a) && (h && !(Et(g) || d && mo(d, g) || fo(d)) && (document && !z && d && !a ? (d.blur && d.blur(), document.body.focus()) : (r = St(g, z, {
        focusOptions: m
      }), be = {})), z = document && document.activeElement, z !== document.body && (zr = Ot(z)), xe = !1), document && d !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var c = document && document.activeElement, y = Zn(g), T = y.map(function(O) {
          var w = O.node;
          return w;
        }).indexOf(c);
        T > -1 && (y.filter(function(O) {
          var w = O.guard, C = O.node;
          return w && C.dataset.focusAutoGuard;
        }).forEach(function(O) {
          var w = O.node;
          return w.removeAttribute("tabIndex");
        }), qr(T, y.length, 1, y), qr(T, -1, -1, y));
      }
    }
  }
  return r;
}, _t = function(r) {
  je() && r && (r.stopPropagation(), r.preventDefault());
}, Or = function() {
  return vr(je);
}, po = function(r) {
  var t = r.target, n = r.currentTarget;
  n.contains(t) || so(n, t);
}, yo = function() {
  return null;
};
process.env.NODE_ENV !== "production" && tt.node.isRequired;
var Rt = function() {
  Sr = !0;
}, Ft = function() {
  Sr = !1, xe = "just", vr(function() {
    xe = "meanwhile";
  });
}, bo = function() {
  document.addEventListener("focusin", _t), document.addEventListener("focusout", Or), window.addEventListener("focus", Rt), window.addEventListener("blur", Ft);
}, go = function() {
  document.removeEventListener("focusin", _t), document.removeEventListener("focusout", Or), window.removeEventListener("focus", Rt), window.removeEventListener("blur", Ft);
};
function Eo(e) {
  return e.filter(function(r) {
    var t = r.disabled;
    return !t;
  });
}
var At = {
  moveFocusInside: St,
  focusInside: Et,
  focusNextElement: to,
  focusPrevElement: no,
  focusFirstElement: oo,
  focusLastElement: ao,
  captureFocusRestore: Ot
};
function wo(e) {
  var r = e.slice(-1)[0];
  r && !ye && bo();
  var t = ye, n = t && r && r.id === t.id;
  ye = r, t && !n && (t.onDeactivation(), e.filter(function(o) {
    var a = o.id;
    return a === t.id;
  }).length || t.returnFocus(!r)), r ? (z = null, (!n || t.observed !== r.observed) && r.onActivation(At), je(), vr(je)) : (go(), z = null);
}
ot.assignSyncMedium(po);
at.assignMedium(Or);
vn.assignMedium(function(e) {
  return e(At);
});
const So = On(Eo, wo)(yo);
fr(it, So);
var Oo = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function To() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = Oo();
  return r && e.setAttribute("nonce", r), e;
}
function Co(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function Po(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var xo = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = To()) && (Co(r, t), Po(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, _o = function() {
  var e = xo();
  return function(r, t) {
    S.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, Tr = function() {
  var e = _o(), r = function(t) {
    var n = t.styles, o = t.dynamic;
    return e(n, o), null;
  };
  return r;
}, Ro = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Qe = function(e) {
  return parseInt(e || "", 10) || 0;
}, Fo = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], n = r[e === "padding" ? "paddingTop" : "marginTop"], o = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [Qe(t), Qe(n), Qe(o)];
}, Ao = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Ro;
  var r = Fo(e), t = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, n - t + r[2] - r[0])
  };
}, Io = Tr(), ge = "data-scroll-locked", ko = function(e, r, t, n) {
  var o = e.left, a = e.top, u = e.right, i = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(Jt, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(i, "px ").concat(n, `;
  }
  body[`).concat(ge, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(n, ";"),
    t === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(n, `;
    `),
    t === "padding" && "padding-right: ".concat(i, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Le, ` {
    right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(De, ` {
    margin-right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(Le, " .").concat(Le, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(De, " .").concat(De, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(ge, `] {
    `).concat(Qt, ": ").concat(i, `px;
  }
`);
}, Ur = function() {
  var e = parseInt(document.body.getAttribute(ge) || "0", 10);
  return isFinite(e) ? e : 0;
}, Mo = function() {
  S.useEffect(function() {
    return document.body.setAttribute(ge, (Ur() + 1).toString()), function() {
      var e = Ur() - 1;
      e <= 0 ? document.body.removeAttribute(ge) : document.body.setAttribute(ge, e.toString());
    };
  }, []);
}, No = function(e) {
  var r = e.noRelative, t = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  Mo();
  var a = S.useMemo(function() {
    return Ao(o);
  }, [o]);
  return S.createElement(Io, { styles: ko(a, !r, o, t ? "" : "!important") });
}, ir = !1;
if (typeof window < "u")
  try {
    var Ae = Object.defineProperty({}, "passive", {
      get: function() {
        return ir = !0, !0;
      }
    });
    window.addEventListener("test", Ae, Ae), window.removeEventListener("test", Ae, Ae);
  } catch {
    ir = !1;
  }
var me = ir ? { passive: !1 } : !1, Lo = function(e) {
  return e.tagName === "TEXTAREA";
}, It = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !Lo(e) && t[r] === "visible")
  );
}, Do = function(e) {
  return It(e, "overflowY");
}, Wo = function(e) {
  return It(e, "overflowX");
}, Yr = function(e, r) {
  var t = r.ownerDocument, n = r;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = kt(e, n);
    if (o) {
      var a = Mt(e, n), u = a[1], i = a[2];
      if (u > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== t.body);
  return !1;
}, jo = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, n = e.clientHeight;
  return [
    r,
    t,
    n
  ];
}, $o = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, n = e.clientWidth;
  return [
    r,
    t,
    n
  ];
}, kt = function(e, r) {
  return e === "v" ? Do(r) : Wo(r);
}, Mt = function(e, r) {
  return e === "v" ? jo(r) : $o(r);
}, Bo = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, zo = function(e, r, t, n, o) {
  var a = Bo(e, window.getComputedStyle(r).direction), u = a * n, i = t.target, m = r.contains(i), v = !1, h = u > 0, s = 0, d = 0;
  do {
    if (!i)
      break;
    var g = Mt(e, i), E = g[0], c = g[1], y = g[2], T = c - y - a * E;
    (E || T) && kt(e, i) && (s += T, d += E);
    var O = i.parentNode;
    i = O && O.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? O.host : O;
  } while (
    // portaled content
    !m && i !== document.body || // self content
    m && (r.contains(i) || r === i)
  );
  return (h && Math.abs(s) < 1 || !h && Math.abs(d) < 1) && (v = !0), v;
}, Ie = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Vr = function(e) {
  return [e.deltaX, e.deltaY];
}, Hr = function(e) {
  return e && "current" in e ? e.current : e;
}, qo = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, Uo = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Yo = 0, he = [];
function Vo(e) {
  var r = S.useRef([]), t = S.useRef([0, 0]), n = S.useRef(), o = S.useState(Yo++)[0], a = S.useState(Tr)[0], u = S.useRef(e);
  S.useEffect(function() {
    u.current = e;
  }, [e]), S.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var c = Kt([e.lockRef.current], (e.shards || []).map(Hr), !0).filter(Boolean);
      return c.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), c.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = S.useCallback(function(c, y) {
    if ("touches" in c && c.touches.length === 2 || c.type === "wheel" && c.ctrlKey)
      return !u.current.allowPinchZoom;
    var T = Ie(c), O = t.current, w = "deltaX" in c ? c.deltaX : O[0] - T[0], C = "deltaY" in c ? c.deltaY : O[1] - T[1], f, D = c.target, j = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in c && j === "h" && D.type === "range")
      return !1;
    var V = window.getSelection(), H = V && V.anchorNode, Q = H ? H === D || H.contains(D) : !1;
    if (Q)
      return !1;
    var U = Yr(j, D);
    if (!U)
      return !0;
    if (U ? f = j : (f = j === "v" ? "h" : "v", U = Yr(j, D)), !U)
      return !1;
    if (!n.current && "changedTouches" in c && (w || C) && (n.current = f), !f)
      return !0;
    var G = n.current || f;
    return zo(G, y, c, G === "h" ? w : C);
  }, []), m = S.useCallback(function(c) {
    var y = c;
    if (!(!he.length || he[he.length - 1] !== a)) {
      var T = "deltaY" in y ? Vr(y) : Ie(y), O = r.current.filter(function(f) {
        return f.name === y.type && (f.target === y.target || y.target === f.shadowParent) && qo(f.delta, T);
      })[0];
      if (O && O.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!O) {
        var w = (u.current.shards || []).map(Hr).filter(Boolean).filter(function(f) {
          return f.contains(y.target);
        }), C = w.length > 0 ? i(y, w[0]) : !u.current.noIsolation;
        C && y.cancelable && y.preventDefault();
      }
    }
  }, []), v = S.useCallback(function(c, y, T, O) {
    var w = { name: c, delta: y, target: T, should: O, shadowParent: Ho(T) };
    r.current.push(w), setTimeout(function() {
      r.current = r.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), h = S.useCallback(function(c) {
    t.current = Ie(c), n.current = void 0;
  }, []), s = S.useCallback(function(c) {
    v(c.type, Vr(c), c.target, i(c, e.lockRef.current));
  }, []), d = S.useCallback(function(c) {
    v(c.type, Ie(c), c.target, i(c, e.lockRef.current));
  }, []);
  S.useEffect(function() {
    return he.push(a), e.setCallbacks({
      onScrollCapture: s,
      onWheelCapture: s,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", m, me), document.addEventListener("touchmove", m, me), document.addEventListener("touchstart", h, me), function() {
      he = he.filter(function(c) {
        return c !== a;
      }), document.removeEventListener("wheel", m, me), document.removeEventListener("touchmove", m, me), document.removeEventListener("touchstart", h, me);
    };
  }, []);
  var g = e.removeScrollBar, E = e.inert;
  return S.createElement(
    S.Fragment,
    null,
    E ? S.createElement(a, { styles: Uo(o) }) : null,
    g ? S.createElement(No, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Ho(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
fr(Qr, Vo);
var Go = function(e) {
  if (typeof document > "u")
    return null;
  var r = Array.isArray(e) ? e[0] : e;
  return r.ownerDocument.body;
}, pe = /* @__PURE__ */ new WeakMap(), ke = /* @__PURE__ */ new WeakMap(), Me = {}, er = 0, Nt = function(e) {
  return e && (e.host || Nt(e.parentNode));
}, Xo = function(e, r) {
  return r.map(function(t) {
    if (e.contains(t))
      return t;
    var n = Nt(t);
    return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, Zo = function(e, r, t, n) {
  var o = Xo(r, Array.isArray(e) ? e : [e]);
  Me[t] || (Me[t] = /* @__PURE__ */ new WeakMap());
  var a = Me[t], u = [], i = /* @__PURE__ */ new Set(), m = new Set(o), v = function(s) {
    !s || i.has(s) || (i.add(s), v(s.parentNode));
  };
  o.forEach(v);
  var h = function(s) {
    !s || m.has(s) || Array.prototype.forEach.call(s.children, function(d) {
      if (i.has(d))
        h(d);
      else
        try {
          var g = d.getAttribute(n), E = g !== null && g !== "false", c = (pe.get(d) || 0) + 1, y = (a.get(d) || 0) + 1;
          pe.set(d, c), a.set(d, y), u.push(d), c === 1 && E && ke.set(d, !0), y === 1 && d.setAttribute(t, "true"), E || d.setAttribute(n, "true");
        } catch (T) {
          console.error("aria-hidden: cannot operate on ", d, T);
        }
    });
  };
  return h(r), i.clear(), er++, function() {
    u.forEach(function(s) {
      var d = pe.get(s) - 1, g = a.get(s) - 1;
      pe.set(s, d), a.set(s, g), d || (ke.has(s) || s.removeAttribute(n), ke.delete(s)), g || s.removeAttribute(t);
    }), er--, er || (pe = /* @__PURE__ */ new WeakMap(), pe = /* @__PURE__ */ new WeakMap(), ke = /* @__PURE__ */ new WeakMap(), Me = {});
  };
}, Ko = function(e, r, t) {
  var n = Array.from(Array.isArray(e) ? e : [e]), o = r || Go(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live], script"))), Zo(n, o, t, "aria-hidden")) : function() {
    return null;
  };
}, Jo = Tr(), Qo = `
 [` + st + `] {
   pointer-events: none !important;
 }
`, ea = function() {
  return S.createElement(Jo, { styles: Qo });
}, Gr = function(e) {
  return "current" in e ? e.current : e;
};
function ra(e) {
  var r = e.setLockProps, t = e.onEscapeKey, n = e.onClickOutside, o = e.shards, a = e.onActivation, u = e.onDeactivation, i = e.noIsolation, m = e.activeNode, v = Se(null), h = Se(0);
  return S.useEffect(function() {
    var s = function(c) {
      c.defaultPrevented || (c.code === "Escape" || c.key === "Escape" || c.keyCode === 27) && t && t(c);
    }, d = function(c) {
      c.defaultPrevented || c.target === v.current || c instanceof MouseEvent && c.button !== 0 || o && o.map(Gr).some(function(y) {
        return y && y.contains(c.target) || y === c.target;
      }) || n && n(c);
    }, g = function(c) {
      d(c), h.current = c.touches.length;
    }, E = function(c) {
      h.current = c.touches.length;
    };
    if (m)
      return m.ownerDocument.addEventListener("keydown", s), m.ownerDocument.addEventListener("mousedown", d), m.ownerDocument.addEventListener("touchstart", g), m.ownerDocument.addEventListener("touchend", E), function() {
        m.ownerDocument.removeEventListener("keydown", s), m.ownerDocument.removeEventListener("mousedown", d), m.ownerDocument.removeEventListener("touchstart", g), m.ownerDocument.removeEventListener("touchend", E);
      };
  }, [m, n, t]), Oe(function() {
    if (m)
      return a && a(m), function() {
        u && u();
      };
  }, [!!m]), Oe(function() {
    if (!(i || !m))
      return Ko(Zt([m], (o || []).map(Gr)), m.ownerDocument.body, st);
  }, [m, i]), Oe(function() {
    return r({
      onMouseDown: function(s) {
        v.current = s.target;
      },
      onTouchStart: function(s) {
        v.current = s.target;
      }
    }), function() {
      r(!1);
    };
  }, []), S.createElement(ea, null);
}
const ta = fr(ct, ra);
var na = function(e) {
  return S.createElement(ta, q({}, e));
}, oa = S.forwardRef(function(e, r) {
  return S.createElement(bn, q({}, e, { ref: r, sideCar: na }));
});
const aa = "common", ia = { closeButtonLabel: "Close" }, ua = {
  namespace: aa,
  strings: ia
}, ca = "_overlay_1r9hh_1", sa = "_focus-container_1r9hh_14", fa = "_size-sm_1r9hh_31", la = "_size-md_1r9hh_38", da = "_size-lg_1r9hh_45", va = "_size-xl_1r9hh_50", ma = "_size-full_1r9hh_56", ha = "_page-width_1r9hh_61", pa = "_size-auto_1r9hh_66", ya = "_modal_1r9hh_71", ba = "_close-icon_1r9hh_80", K = {
  overlay: ca,
  focusContainer: sa,
  sizeSm: fa,
  sizeMd: la,
  sizeLg: da,
  sizeXl: va,
  sizeFull: ma,
  pageWidth: ha,
  sizeAuto: pa,
  modal: ya,
  closeIcon: ba
}, ga = {
  sm: K.sizeSm,
  md: K.sizeMd,
  lg: K.sizeLg,
  xl: K.sizeXl,
  full: K.sizeFull,
  auto: K.sizeAuto,
  pageWidth: K.pageWidth
};
function Fa(e) {
  const {
    closeOnClickOutside: r = !1,
    closeOnEscape: t = !1,
    onClose: n,
    overlayClassName: o,
    size: a = "md",
    withoutCloseButton: u = !1,
    className: i,
    headerActions: m,
    modalContainerClassName: v,
    ...h
  } = e, s = Gt(ua);
  Oe(
    () => {
      const c = document.documentElement.style.scrollbarGutter;
      return document.documentElement.style.scrollbarGutter = "initial", () => {
        document.documentElement.style.scrollbarGutter = c;
      };
    },
    []
  );
  const d = ga[a], g = ie(() => {
    r && n && n();
  }, [n, r]), E = ie(() => {
    t && n && n();
  }, [n, t]);
  return /* @__PURE__ */ ve(Ht, { children: /* @__PURE__ */ ve("div", { className: $e(K.overlay, o), children: /* @__PURE__ */ ve(
    oa,
    {
      className: $e(K.focusContainer, v, d),
      onClickOutside: g,
      onEscapeKey: E,
      gapMode: "padding",
      children: /* @__PURE__ */ ve(
        Vt,
        {
          ...h,
          withPadding: !0,
          withoutWrapInHeader: !0,
          withoutWrapInFooter: !0,
          className: $e(K.modal, i),
          withContentOverflow: !0,
          headerActions: !u || m ? /* @__PURE__ */ Dt(Wt, { children: [
            m,
            /* @__PURE__ */ ve(
              Yt,
              {
                name: void 0,
                onClick: n,
                styleVariant: "action",
                colorVariant: "text",
                title: s.closeButtonLabel,
                children: /* @__PURE__ */ ve(Ut, { className: K.closeIcon })
              }
            )
          ] }) : void 0
        }
      )
    }
  ) }) });
}
export {
  Fa as default
};
